import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import style from './JForm.module.css'

const DonationForm = () => {


  const [formData, setFormData] = useState({
    // renamed seva flags
    annadanaSeva: false,            // was annadaanSeva
    deepaDanaSeva: false,           // was donneSeva

    // amounts (kept existing related fields but renamed where they reference sevas)
    selectedAnnadaanAmount: null,
    customAnnadaanAmount: "",

    selectedDeepaDanaAmount: null,   // was selectedDonneCupAmount
    customDeepaDanaAmount: "",      // was customDonneCupAmount

    pushpalankaraSeva: false,       // was vastraAlankarSeva
    visheshaNaivedyaSeva: false,    // was chappanBhogSeva
    kirtanSeva: false,              // was pushpaMalaSeva
    gauSeva: false,                 // was yejnaSeva
    spiritualDiscourseSeva: false,  // was pushpanjaliSeva
    // mandirAlnkarnaSeva: false,
    donateByWish: false,

    sevaDate: "",
    honoureeName: "",
    relationship: "",
    donorName: "",
    email: "",
    mobile: "",
    dob: "",
    receive80G: false,
    panNumber: "",
    receiveMahaPrasadam: false,

    // selected flags / amount holders (renamed where they referenced sevas)
    selectedAnnadaanAmount: false,
    selectedPushpalankaraAmount: false,      // was selectedvastraAlankarAmount
    selectedVisheshaNaivedyaAmount: false,   // was selectedChappanBhogAmount
    selectedKirtanAmount: false,             // was selectedPushpaMalaAmount
    selectedGauAmount: false,                // was selectedYejnaAmount
    selectedSpiritualDiscourseAmount: false, // was selectedPushpanjaliSevaAmount
    // selectedMandirAlnkarnaAmount: false,
    selectedDonationAmount: null,

    // custom amounts renamed
    customAnnadaanAmount: "",
    customPushpalankaraAmount: "",    // was customvastraAlankarAmount
    customVisheshaNaivedyaAmount: "", // was customChappanBhogAmount
    customKirtanAmount: "",           // was customPushpaMalaAmount
    customGauAmount: "",              // was customYejnaAmount
    customSpiritualDiscourseAmount: "", // was customPushpanjaliSevaAmount
    // customMandirAlnkarnaAmount: "",
    customDonationAmount: "",

    mahaPrasadamDetails: {
      doorNumber: "",
      houseName: "",
      streetName: "",
      area: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [show80GDetails, setShow80GDetails] = useState(false);
  const [showMahaPrasadamDetails, setShowMahaPrasadamDetails] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      };

      // map custom inputs to their selected amount fields (renamed)
      if (name === "customAnnadaanAmount" && value) {
        updatedData.selectedAnnadaanAmount = parseFloat(value);
      } else if (name === "customPushpalankaraAmount" && value) {
        updatedData.selectedPushpalankaraAmount = parseFloat(value);
      } else if (name === "customVisheshaNaivedyaAmount" && value) {
        updatedData.selectedVisheshaNaivedyaAmount = parseFloat(value);
      } else if (name === "customKirtanAmount" && value) {
        updatedData.selectedKirtanAmount = parseFloat(value);
      } else if (name === "customGauAmount" && value) {
        updatedData.selectedGauAmount = parseFloat(value);
      } else if (name === "customSpiritualDiscourseAmount" && value) {
        updatedData.selectedSpiritualDiscourseAmount = parseFloat(value);
      } else if (name === "customDonationAmount" && value) {
        updatedData.selectedDonationAmount = parseFloat(value);
      } else if (name === "customDeepaDanaAmount" && value) {
        updatedData.selectedDeepaDanaAmount = parseFloat(value);
      } else if (name === "customFullPlateAmount" && value) {
        updatedData.selectedFullPlateAmount = parseFloat(value);
      }

      return updatedData;
    });
  };

  const handle80GCheckboxChange = (e) => {
    setShow80GDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleMahaPrasadamCheckboxChange = (e) => {
    setShowMahaPrasadamDetails(e.target.checked);
    handleInputChange(e);
  };
  const handleAmountSelect = (section, amount) => {
    setFormData((prevData) => {
      switch (section) {
        case "annadaan":
          return {
            ...prevData,
            selectedAnnadaanAmount:
              prevData.selectedAnnadaanAmount === amount ? null : amount,
            customAnnadaanAmount: "",
            selectedFullPlateAmount: null,
            customFullPlateAmount: "",
            selectedDeepaDanaAmount: null,
            customDeepaDanaAmount: "",
          };
        case "fullPlate":
          return {
            ...prevData,
            selectedFullPlateAmount:
              prevData.selectedFullPlateAmount === amount ? null : amount,
            customFullPlateAmount: "",
            selectedAnnadaanAmount: null,
            customAnnadaanAmount: "",
          };
        case "donneCup":
          return {
            ...prevData,
            // 'donneCup' still used as section name for Deepa Dana presets
            selectedDeepaDanaAmount:
              prevData.selectedDeepaDanaAmount === amount ? null : amount,
            customDeepaDanaAmount: "",
            selectedAnnadaanAmount: null,
            customAnnadaanAmount: "",
          };
        case "vastraAlankar":
          return {
            ...prevData,
            selectedPushpalankaraAmount:
              prevData.selectedPushpalankaraAmount === amount ? null : amount,
            customPushpalankaraAmount: "",
          };
        case "chappanBhog":
          return {
            ...prevData,
            selectedVisheshaNaivedyaAmount:
              prevData.selectedVisheshaNaivedyaAmount === amount ? null : amount,
            customVisheshaNaivedyaAmount: "",
          };
        case "pushpaMala":
          return {
            ...prevData,
            selectedKirtanAmount:
              prevData.selectedKirtanAmount === amount ? null : amount,
            customKirtanAmount: "",
          };
        case "yejna":
          return {
            ...prevData,
            selectedGauAmount:
              prevData.selectedGauAmount === amount ? null : amount,
            customGauAmount: "",
          };
        case "pushpanjaliSeva":
          return {
            ...prevData,
            selectedSpiritualDiscourseAmount:
              prevData.selectedSpiritualDiscourseAmount === amount ? null : amount,
            customSpiritualDiscourseAmount: "",
          };

        default:
          return prevData;
      }
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.donorName) newErrors.donorName = "Donor name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.mobile) newErrors.mobile = "Mobile number is required";
    if (!formData.dob) newErrors.dob = "Date of birth is required";
    if (formData.receive80G && !formData.panNumber)
      newErrors.panNumber = "PAN number is required for 80G certificate";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getTotalAmount = () => {
    const annadaanAmount =
      formData.selectedAnnadaanAmount ||
      parseFloat(formData.customAnnadaanAmount) ||
      0;
    const fullPlateAmount =
      formData.selectedFullPlateAmount ||
      parseFloat(formData.customFullPlateAmount) ||
      0;
    const deepaDanaAmount =
      formData.selectedDeepaDanaAmount ||
      parseFloat(formData.customDeepaDanaAmount) ||
      0;
    const pushpalankaraAmount =
      formData.selectedPushpalankaraAmount ||
      parseFloat(formData.customPushpalankaraAmount) ||
      0;
    const visheshaNaivedyaAmount =
      formData.selectedVisheshaNaivedyaAmount ||
      parseFloat(formData.customVisheshaNaivedyaAmount) ||
      0;
    const kirtanAmount =
      formData.selectedKirtanAmount ||
      parseFloat(formData.customKirtanAmount) ||
      0;
    const gauAmount =
      formData.selectedGauAmount ||
      parseFloat(formData.customGauAmount) ||
      0;
    const spiritualDiscourseAmount =
      formData.selectedSpiritualDiscourseAmount ||
      parseFloat(formData.customSpiritualDiscourseAmount) ||
      0;

    const donationByWishAmount =
      formData.selectedDonationAmount ||
      parseFloat(formData.customDonationAmount) ||
      0;

    return (
      annadaanAmount +
      fullPlateAmount +
      deepaDanaAmount +
      pushpalankaraAmount +
      visheshaNaivedyaAmount +
      kirtanAmount +
      gauAmount +
      spiritualDiscourseAmount +
      donationByWishAmount
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const totalAmount = getTotalAmount();
    let isFormDataStored = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: totalAmount,
          currency: "INR",
        }
      );

      const order = response.data;
      let sevaDescription = "Donation Payment";

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: totalAmount * 100,
        currency: "INR",
        name: "ISKCON Janmashtami Donation",
        description: sevaDescription,
        order_id: order.id,
        notes: {
          donorName: formData.donorName,
          donorPhoneNumber: formData.mobile,
          donorEmail: formData.email,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: { ...formData, amount: totalAmount },
              }
            );

            if (verificationResponse.data.success) {
              alert("Payment Successful!");
              if (!isFormDataStored) {
                await storeFormData("Payment Successful");
                isFormDataStored = true;
              }
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storeFormData("Payment Failed");
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobile,
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storeFormData("Payment Failed");
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storeFormData("Payment Failed");
        isFormDataStored = true;
      }
    }
  };

  const storeFormData = async (paymentStatus) => {
    const totalDonationAmount = getTotalAmount();

    // Prepare data in the format expected by your Apps Script
    const formDataToSend = new URLSearchParams();

    // Add all fields to the form data
    formDataToSend.append("paymentStatus", paymentStatus);

    // updated keys & amounts to the new seva names
    formDataToSend.append("deepaDanaSeva", formData.deepaDanaSeva ? "Yes" : "No");
    formDataToSend.append(
      "deepaDanaAmount",
      formData.selectedDeepaDanaAmount || formData.customDeepaDanaAmount || 0
    );

    formDataToSend.append("annadanaSeva", formData.annadanaSeva ? "Yes" : "No");
    formDataToSend.append(
      "annadanaAmount",
      formData.selectedAnnadaanAmount || formData.customAnnadaanAmount || 0
    );

    formDataToSend.append(
      "gauSeva",
      formData.gauSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "gauSevaAmount",
      formData.selectedGauAmount || formData.customGauAmount || 0
    );

    formDataToSend.append(
      "pushpalankaraSeva",
      formData.pushpalankaraSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "pushpalankaraAmount",
      formData.selectedPushpalankaraAmount || formData.customPushpalankaraAmount || 0
    );

    formDataToSend.append(
      "visheshaNaivedyaSeva",
      formData.visheshaNaivedyaSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "visheshaNaivedyaAmount",
      formData.selectedVisheshaNaivedyaAmount || formData.customVisheshaNaivedyaAmount || 0
    );

    formDataToSend.append(
      "kirtanSeva",
      formData.kirtanSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "kirtanAmount",
      formData.selectedKirtanAmount || formData.customKirtanAmount || 0
    );

    formDataToSend.append(
      "spiritualDiscourseSeva",
      formData.spiritualDiscourseSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "spiritualDiscourseAmount",
      formData.selectedSpiritualDiscourseAmount || formData.customSpiritualDiscourseAmount || 0
    );

    formDataToSend.append("donateByWish", formData.donateByWish ? "Yes" : "No");
    formDataToSend.append(
      "donationByWishAmount",
      formData.selectedDonationAmount || formData.customDonationAmount || 0
    );

    formDataToSend.append("totalDonationAmount", totalDonationAmount);
    formDataToSend.append("sevaDate", formData.sevaDate || "");
    formDataToSend.append("honoureeName", formData.honoureeName || "");
    formDataToSend.append("relationship", formData.relationship || "");
    formDataToSend.append("donorName", formData.donorName || "");
    formDataToSend.append("email", formData.email || "");
    formDataToSend.append("mobile", formData.mobile || "");
    formDataToSend.append("dob", formData.dob || "");
    formDataToSend.append("receive80G", formData.receive80G ? "Yes" : "No");
    formDataToSend.append(
      "panNumber",
      formData.receive80G ? formData.panNumber : ""
    );

    formDataToSend.append(
      "receiveMahaPrasadam",
      formData.receiveMahaPrasadam ? "Yes" : "No"
    );
    formDataToSend.append(
      "doorNumber",
      formData.mahaPrasadamDetails.doorNumber || ""
    );
    formDataToSend.append(
      "houseName",
      formData.mahaPrasadamDetails.houseName || ""
    );
    formDataToSend.append(
      "streetName",
      formData.mahaPrasadamDetails.streetName || ""
    );
    formDataToSend.append("area", formData.mahaPrasadamDetails.area || "");
    formDataToSend.append(
      "country",
      formData.mahaPrasadamDetails.country || ""
    );
    formDataToSend.append("state", formData.mahaPrasadamDetails.state || "");
    formDataToSend.append("city", formData.mahaPrasadamDetails.city || "");
    formDataToSend.append(
      "pincode",
      formData.mahaPrasadamDetails.pincode || ""
    );

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbxngky7O0WaO6_KRr0FpjmRRFBsLJEswsm89-Z7GJceVR6ttCGXgcW8J_qoWrq6zCAD0A/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formDataToSend.toString(),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      console.log("Data stored successfully in Google Sheets");
      return true;
    } catch (error) {
      console.error("Error storing data:", error);
      alert(
        "An error occurred while storing your donation details. Please try again."
      );
      return false;
    }
  };
  return (
    <div className="JForm">
      {/* Donation Form - Right Side */}
      <div className=" xl:flex xl:justify-center xl:pt-[3.5rem] mb-8 md:mt-4 mt-8 ">
        <div className="donationDetail bg-[#C61D21] py-10 px-2 rounded-3xl xl:h-full xl:p-8 xl:max-w-[800px] w-full">
          <form onSubmit={handleSubmit} className="text-white">
            <h2 className="text-center text-2xl xl:text-4xl">
              Donation Details
            </h2>

            <div className="innerForm sevaContainer">
              <div>
                {/* ANNADANA SEVA */}
                <label className="block">
                  <input
                    type="checkbox"
                    name="annadanaSeva"
                    checked={formData.annadanaSeva}
                    onChange={handleInputChange}
                    style={{ accentColor: "blue" }}
                  />
                  ANNADANA SEVA
                </label>

                {formData.annadanaSeva && (
                  <div className="grid grid-cols-2 gap-2 mt-0 ml-4">
                    {[
                      { text: "10,000/-", amount: 10000 },
                      { text: "5000/-", amount: 5000 },
                      { text: "2500/-", amount: 2500 },
                      { text: "1000/-", amount: 1000 },
                      { text: "500 /-", amount: 500 },
                    ].map((item) => (
                      <button
                        className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                        type="button"
                        key={`annadaan-${item.amount}`}
                        onClick={() => handleAmountSelect("fullPlate", item.amount)}
                        style={{
                          backgroundColor:
                            formData.selectedFullPlateAmount === item.amount
                              ? "#fac785"
                              : "",
                        }}
                      >
                        {item.text}
                      </button>
                    ))}
                    <input
                      type="number"
                      name="customFullPlateAmount"
                      placeholder="₹ Donate as you wish"
                      value={formData.customFullPlateAmount || ""}
                      onChange={handleInputChange}
                      className="col-span-2 p-3 border rounded-xl my-1 mx-1 text-black"
                    />
                  </div>
                )}

                {/* DEEPA DANA SEVA */}
                <label className="block mt-3">
                  <input
                    type="checkbox"
                    name="deepaDanaSeva"
                    checked={formData.deepaDanaSeva}
                    onChange={handleInputChange}
                    style={{ accentColor: "blue" }}
                  />
                  DEEPA DANA SEVA
                </label>

                {formData.deepaDanaSeva && (
                  <div className="grid grid-cols-2 gap-2 mt-0 ml-4">
                    {[
                      { text: "10,000/-", amount: 10000 },
                      { text: "5000/-", amount: 5000 },
                      { text: "2500/-", amount: 2500 },
                      { text: "1000/-", amount: 1000 },
                      { text: "500 /-", amount: 500 },
                    ].map((item) => (
                      <button
                        className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                        type="button"
                        key={`donne-${item.amount}`}
                        onClick={() => handleAmountSelect("donneCup", item.amount)}
                        style={{
                          backgroundColor:
                            formData.selectedDeepaDanaAmount === item.amount
                              ? "#fac785"
                              : "",
                        }}
                      >
                        {item.text}
                      </button>
                    ))}
                    <input
                      type="number"
                      name="customDeepaDanaAmount"
                      placeholder="₹ Donate as you wish"
                      value={formData.customDeepaDanaAmount || ""}
                      onChange={handleInputChange}
                      className="col-span-2 p-3 border rounded-xl my-1 mx-1 text-black"
                    />
                  </div>
                )}
              </div>

              <label>
                <input
                  type="checkbox"
                  name="pushpalankaraSeva"
                  checked={formData.pushpalankaraSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                PUSHPALANKARA SEVA
              </label>
              {formData.pushpalankaraSeva && (
                <div className="grid grid-cols-2 -mt-4">
                  {[30000, 20000, 15000, 5000].map((amount) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={amount}
                      onClick={() =>
                        handleAmountSelect("vastraAlankar", amount)
                      }
                      style={{
                        backgroundColor:
                          formData.selectedPushpalankaraAmount === amount
                            ? "#fac785"
                            : "",
                        margin: "5px",
                      }}
                    >
                      ₹ {amount.toLocaleString("en-IN")}/-
                    </button>
                  ))}
                  <input
                    type="number"
                    name="customPushpalankaraAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customPushpalankaraAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                  />
                </div>
              )}

              <label>
                <input
                  type="checkbox"
                  name="visheshaNaivedyaSeva"
                  checked={formData.visheshaNaivedyaSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                SADHU BHOJ
              </label>
              {formData.visheshaNaivedyaSeva && (
                <div className="grid grid-cols-2 -mt-4">
                  {[15000, 10000, 5000].map((amount) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={amount}
                      onClick={() =>
                        handleAmountSelect("chappanBhog", amount)
                      }
                      style={{
                        backgroundColor:
                          formData.selectedVisheshaNaivedyaAmount === amount
                            ? "#fac785"
                            : "",
                        margin: "5px",
                      }}
                    >
                      ₹ {amount.toLocaleString("en-IN")}
                    </button>
                  ))}
                  <input
                    type="number"
                    name="customVisheshaNaivedyaAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customVisheshaNaivedyaAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                  />
                </div>
              )}

              

              <label>
                <input
                  type="checkbox"
                  name="gauSeva"
                  checked={formData.gauSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                GAU SEVA
              </label>
              {formData.gauSeva && (
                <div className="grid grid-cols-2 -mt-4">
                  {[10000, 5000, 2500, 500].map((amount) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={amount}
                      onClick={() => handleAmountSelect("yejna", amount)}
                      style={{
                        backgroundColor:
                          formData.selectedGauAmount === amount
                            ? "#fac785"
                            : "",
                        margin: "5px",
                      }}
                    >
                      ₹ {amount.toLocaleString("en-IN")} /-
                    </button>
                  ))}

                  <input
                    type="number"
                    name="customGauAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customGauAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                  />
                </div>
              )}
              <label>
                <input
                  type="checkbox"
                  name="spiritualDiscourseSeva"
                  checked={formData.spiritualDiscourseSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                VISHESHA NAIVEDYA SEVA
              </label>
              {formData.spiritualDiscourseSeva && (
                <div className="grid grid-cols-2 -mt-4">
                  {[5000, 2500, 1000, 500].map((amount) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={amount}
                      onClick={() => handleAmountSelect("pushpanjaliSeva", amount)}
                      style={{
                        backgroundColor:
                          formData.selectedSpiritualDiscourseAmount === amount
                            ? "#fac785"
                            : "",
                        margin: "5px",
                      }}
                    >
                      ₹ {amount.toLocaleString("en-IN")} /-
                    </button>
                  ))}

                  <input
                    type="number"
                    name="customSpiritualDiscourseAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customSpiritualDiscourseAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                  />
                </div>
              )}
              <label>
                <input
                  type="checkbox"
                  name="donateByWish"
                  checked={formData.donateByWish}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                DONATE AS YOU WISH

              </label>
              {formData.donateByWish && (
                <div>
                  <input
                    type="number"
                    name="customDonationAmount"
                    placeholder="₹ Donate by your wish"
                    value={formData.customDonationAmount || ""}
                    onChange={handleInputChange}
                    className="w-full p-3 border rounded-xl my-1 text-black"
                  />
                </div>
              )}
            </div>

            <div className="innerForm">
              <h3 className="text-center">Personal Details</h3>
              <label className="xl:w-full">
                <input
                  type="text"
                  name="donorName"
                  value={formData.donorName}
                  onChange={handleInputChange}
                  placeholder="Donor Name"
                  className="mt-2"
                />
                {errors.donorName && (
                  <span className="block -mt-2 ml-2">
                    {errors.donorName}
                  </span>
                )}
              </label>
              <label className="xl:w-full">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email ID"
                />
                {errors.email && (
                  <span className="block -mt-2 ml-2">{errors.email}</span>
                )}
              </label>
              <div className="flex gap-2">
                <label className="flex-1">
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    placeholder="Mobile Number"
                    className="p-[10px] md:w-full"
                  />
                  {errors.mobile && (
                    <span className="block mt-1 ml-2">{errors.mobile}</span>
                  )}
                </label>
                <label className="flex-1">
                  <input
                    type="text"
                    name="dob"
                    value={formData.dob}
                    onChange={handleInputChange}
                    className="text-[#909192] p-2 border rounded-md"
                    placeholder="Date Of Birth"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                  />
                  {errors.dob && (
                    <span className="block -mt-2 ml-2">{errors.dob}</span>
                  )}
                </label>
              </div>
            </div>
            <p className="text-white mt-2 text-[10px]">
              (Sankalpa and Archana will be performed for you on your
              birthday)
            </p>

            <p className="text-white -mt-2 text-xs">
              By continuing, you are agreeing to{" "}
              <a className="underline text-[#EEF9A3]">
                Terms of Use and Privacy Policy
              </a>
            </p>

            <div className="px-3 tandd mt-8">
              <label>
                <input
                  type="checkbox"
                  name="receive80G"
                  checked={formData.receive80G}
                  onChange={handle80GCheckboxChange}
                  style={{ accentColor: "blue" }}
                />
                I would like to receive 80(G) Certificate
              </label>
              {show80GDetails && (
                <div className="mb-3">
                  <p className="text-white text-[10px] text-left ml-2">
                    Finance Act 2021 mandates uploading donation details for
                    80(G) deductions. Ensure PAN and address details are
                    provided.
                  </p>
                  <input
                    type="text"
                    name="panNumber"
                    value={formData.panNumber}
                    onChange={handleInputChange}
                    placeholder="Pan Number *"
                    className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                    required
                  />
                  <input
                    type="text"
                    name="doorNumber"
                    placeholder="Door Number"
                    className="text-black"
                    value={formData.mahaPrasadamDetails.doorNumber}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          doorNumber: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="houseName"
                    placeholder="House / Apartment / Building Name"
                    value={formData.mahaPrasadamDetails.houseName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          houseName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="streetName"
                    placeholder="Street Name"
                    value={formData.mahaPrasadamDetails.streetName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          streetName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="area"
                    placeholder="Location / Area"
                    value={formData.mahaPrasadamDetails.area}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          area: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="country"
                    placeholder="Country"
                    value={formData.mahaPrasadamDetails.country}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          country: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="state"
                    placeholder="State"
                    value={formData.mahaPrasadamDetails.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          state: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="city"
                    placeholder="City"
                    value={formData.mahaPrasadamDetails.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          city: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="pincode"
                    placeholder="Pincode"
                    value={formData.mahaPrasadamDetails.pincode}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          pincode: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              )}

              <label>
                <input
                  type="checkbox"
                  name="receiveMahaPrasadam"
                  checked={formData.receiveMahaPrasadam}
                  onChange={handleMahaPrasadamCheckboxChange}
                  style={{ accentColor: "blue" }}
                />
                I would like to receive Maha prasadam (Only within India)
              </label>
              {showMahaPrasadamDetails && (
                <div className="mt-3">
                  <input
                    type="text"
                    name="doorNumber"
                    placeholder="Door Number"
                    className="text-black"
                    value={formData.mahaPrasadamDetails.doorNumber}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          doorNumber: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="houseName"
                    placeholder="House / Apartment / Building Name"
                    value={formData.mahaPrasadamDetails.houseName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          houseName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="streetName"
                    placeholder="Street Name"
                    value={formData.mahaPrasadamDetails.streetName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          streetName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="area"
                    placeholder="Location / Area"
                    value={formData.mahaPrasadamDetails.area}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          area: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="country"
                    placeholder="Country"
                    value={formData.mahaPrasadamDetails.country}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          country: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="state"
                    placeholder="State"
                    value={formData.mahaPrasadamDetails.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          state: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="city"
                    placeholder="City"
                    value={formData.mahaPrasadamDetails.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          city: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="pincode"
                    placeholder="Pincode"
                    value={formData.mahaPrasadamDetails.pincode}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          pincode: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              )}
            </div>

            <div className="flex justify-center mt-8">
              <button
                type="submit"
                className="bg-[#FAE29C] text-black px-12 py-3 rounded-2xl font-bold"
              >
                Donate{" "}
                {getTotalAmount() > 0
                  ? "₹ " + getTotalAmount().toLocaleString("en-IN")
                  : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default DonationForm
